import React from "react";
import "./styles/WindowsXPForm.css"; // Import the stylesheet for the form styles
import Draggable from "react-draggable";

const WindowsXPForm = ({ onClose }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Add your form submission logic here
  };

  return (
    <Draggable>
      <div className="windows-xp-form">
        <div className="title-bar-two">
          <div className="form-title">Contact me</div>
          <button className="form-close-button" onClick={onClose}>
            X
          </button>
        </div>
        <div className="form-content">
          <form onSubmit={handleSubmit}>
            <label htmlFor="name">Name:</label>
            <input type="text" id="name" name="name" required />

            <label htmlFor="email">Email:</label>
            <input type="email" id="email" name="email" required />

            <label htmlFor="message">Message:</label>
            <textarea id="message" name="message" rows="4" required></textarea>

            <button type="submit" className="submit-button">
              Submit
            </button>
          </form>
        </div>
      </div>
    </Draggable>
  );
};

export default WindowsXPForm;
